//import usHrrAll from '../components/Map/us_hrr_values.json1'

export default function hrrsMap(hrrMapJson) {
  let idNameMap = new Map()
  hrrMapJson['features'].forEach((value) => {
    idNameMap[value.properties['HRRNUM']] = value.properties['HRRCITY']
  })
  return idNameMap
}
